(ns ui.view.entity-creator.investor.model)

(def root ::state)
(def root-path [root])

(defn i-root
  [ident]
  {:pre [(vector? ident)]}
  (into root-path ident))

(def processing-key :processing)
(def processing-path [processing-key])
(defn processing-full-path
  [ident]
  (into (i-root ident) processing-path))

(def creating-key :creating)
(def creating-path [creating-key])
(defn creating-full-path
  [ident]
  (into (i-root ident) creating-path))

(def processing-start-time-key :processing-start-time)
(def processing-start-time-path [processing-start-time-key])
(defn processing-start-time-full-path
  [ident]
  (into (i-root ident) processing-start-time-path))

(def created-entity-key :created-entity)
(def created-entity-path [created-entity-key])
(defn created-entity-full-path
  [ident]
  (into (i-root ident) created-entity-path))

(def callbacks-key :callbacks)
(def callbacks-path [callbacks-key])
(defn callbacks-full-path
  [ident]
  (into (i-root ident) callbacks-path))

(def entity-type-key :entity-type)
(def entity-type-path [entity-type-key])
(defn entity-type-full-path
  [ident]
  (into (i-root ident) entity-type-path))

(def current-view-key :current-view)
(def current-view-path [current-view-key])
(defn current-view-full-path
  [ident]
  (into (i-root ident) current-view-path))

(def selected-legal-entity-key :selected-legal-entity)
(def selected-legal-entity-path [selected-legal-entity-key])
(defn selected-legal-entity-full-path
  [ident]
  (into (i-root ident) selected-legal-entity-path))

(def initial-legal-entity-value-key :initial-legal-entity-value)
(def initial-legal-entity-value-path [initial-legal-entity-value-key])
(defn initial-legal-entity-value-full-path
  [ident]
  (into (i-root ident) initial-legal-entity-value-path))

;;; Subscriptions:
(def root-state ::root-state)
(def state ::state)

(def current-view ::current-view)
(def selected-legal-entity ::selected-legal-entity)
(def investor ::investor)

(def processing? ::processing?)
(def creating? ::creating?)

(def subview ::subview)

;;; Events:
(def initialize ::initialize)
(def close-creator ::close-creator)
(def unselect-legal-entity ::unselect-legal-entity)
(def confirm-legal-entity ::confirm-legal-entity)
(def legal-entity-load-failed ::legal-entity-load-failed)
(def navigate-back ::navigate-back)
(def navigate-next ::navigate-next)
(def start-create ::start-create)
(def create-error ::create-error)
(def create-success ::create-success)
(def processing-done ::processing-done)
(def finish ::finish)

;;; Effects
(def callback-fx ::callback-fx)

;;; Coeffects
(def selected-legal-entity-cofx ::selected-legal-entity-cofx)
(def existing-investor-cofx ::existing-investor-cofx)

;;; Helpers
(defn resolve-investor-creator-ident
  [{:keys [ident]}]
  (into ident [:nested :main-entity]))

(defn resolve-legal-entity-creator-ident
  [{:keys [ident]}]
  (into ident [:nested :legal-entity]))
